import { Box, Card, Theme, styled, useMediaQuery } from "@mui/material";
import { DatagridConfigurable, DatagridConfigurableProps, List, ListProps, useSidebarState } from "react-admin";

import CustomPagination from "./CustomPagination";
import React from "react";
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle<{ openedLeftMenu: boolean, isSmall: boolean }>`
    .RaDatagrid-root > div:not(.RaDatagrid-tableWrapper) {
        z-index: 100000;
        top: 130px;
        position: fixed !important;
        width: calc(100vw - ${({openedLeftMenu, isSmall}) => isSmall ? 0 : openedLeftMenu ? 250 : 60}px);
    }
    body {
        overflow: hidden;
    }
`;
const StyledDatagridConfigurable = styled(DatagridConfigurable)(({ theme }) => ({
    "& .RaDatagrid-cell, & .RaDatagrid-headerCell": {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    "& .RaDatagrid-headerCell, & .RaDatagrid-rowCell": {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    "& .RaDatagrid-cell:last-child, & .RaDatagrid-headerCell:last-child": {
        borderRight: "none",
    },
}));

type ResponsiveListProps = {
    listProps: Omit<ListProps, "children">;
    datagridProps: Omit<DatagridConfigurableProps, "children">;
    children: React.ReactNode[];
};

export const ResponsiveList = ({ children, listProps, datagridProps }: ResponsiveListProps) => {
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    const [openedLeftMenu] = useSidebarState();

    const filterHeight = (document.getElementsByClassName('RaList-actions') as any)?.[0]?.offsetHeight;

    return (
        <>
            <GlobalStyles openedLeftMenu={openedLeftMenu} isSmall={isSmall}  />
            <List
                perPage={50}
                {...listProps}
                pagination={<CustomPagination />}
                sx={{
                    width: `calc(100vw - ${isSmall ? "0px" : openedLeftMenu ? "260px" : "60px"})`,
                }}
            >
                <Card
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: `calc(100vh - ${isSmall ? `${150 + filterHeight}px` : "200px"})`,
                        overflow: "hidden",
                        width: `calc(100vw - ${isSmall ? "0px" : openedLeftMenu ? "260px" : "60px"})`,
                    }}
                >
                    <Box sx={{ flex: 1, overflow: "auto" }}>
                        <StyledDatagridConfigurable
                            sx={{
                                "& tr td": { paddingTop: 0, paddingBottom: 0 },
                                "& .RaDatagrid-rowOdd": { backgroundColor: "#f0f0f0" },
                                "& thead": {
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "white",
                                    zIndex: 2,
                                },
                            }}
                            {...datagridProps}
                        >
                            {React.Children.toArray(children)}
                        </StyledDatagridConfigurable>
                    </Box>
                </Card>
            </List>
        </>
    );
};
